<script setup lang="ts">

import { useJupiterProps } from '@modules/Jupiter';
import { useNotify } from '@library/Components';
import { useRouter } from 'vue-router';
import { useUser } from '@domain/Security/User';
import { useAppConfiguration } from '@domain/AppConfiguration';

const jupiter = useJupiterProps();
const user = useUser();
const router = useRouter();
const url = window.location.origin + router.currentRoute.value.fullPath;
const appConfiguration = useAppConfiguration();

/**
 * Copies the coordinates to the clipboard
 */
async function copyToClipboard()
{
    const jupiterData = Object.assign( {}, jupiter ) as any;
    delete jupiterData.deferredIsReady;

    const userData = Object.assign( {}, user ) as any;
    const appConfigurationData = Object.assign( {}, appConfiguration ) as any;
    const data = { appConfiguration: appConfigurationData, jupiter: jupiterData, user: userData };
    const dataString = JSON.stringify( data );

    await navigator.clipboard.writeText( dataString );
    await useNotify( 'Properties were copied to the clipboard', '' );

}

</script>

<template>

    <div class="flex flex-col w-full h-full gap-2">

        <h1>App Configuration</h1>
        <div class="mb-3 opacity-60 w-full overflow-scroll">
            <pre>App Name: {{ appConfiguration.name }}</pre>
            <pre>Brand Name: {{ appConfiguration.brandName }}</pre>
            <pre>Theme: {{ appConfiguration.theme }}</pre>
            <pre>Dark Mode: {{ appConfiguration.isDarkMode }}</pre>
            <pre>Is Generic App: {{ appConfiguration.isGeneric }}</pre>
            <pre>Loaded From Server: {{ appConfiguration.isValid }}</pre>
        </div>

        <h1>Jupiter Settings</h1>
        <div class="mb-3 opacity-60 w-full overflow-scroll">
            <pre>Page: {{ url }}</pre>
            <pre>AppConsumerId: {{ jupiter.appConsumerId }}</pre>
            <pre>AppVehicleId: {{ jupiter.appVehicleId }}</pre>
        </div>

        <h1>User</h1>
        <div class="mb-3 opacity-60 w-full overflow-scroll">
            <pre>BusinessConsumerId: {{ user?.businessConsumerId }}</pre>
            <pre>BusinessId: {{ user?.businessId }}</pre>
            <pre>AppConsumerId: {{ user?.appConsumerId }}</pre>
            <pre>vehicleId: {{ user?.activeVehicle == null ? 'null' : user?.activeVehicle?.vehicleId }}</pre>
        </div>

        <Button variant="outlined"
                @click="copyToClipboard()">
            Copy To Clipboard
        </Button>

    </div>

</template>
@domain/AppConfiguration
